const selectAutoModel = () => null;

export default selectAutoModel;
